import { Injectable } from '@angular/core';

export interface ComplaintListState {
  filters: {
    complainantName: string;
    complaintNo: string;
    complaintCategoryId: any;
    complaintSubcategoryId: any;
    currentProcessId: any;
    divisionId: any;
    districtId: any;
    tehsilId: any;
    mouzaId: any;
    cnic: string;
    cellPhoneNo: string;
    email: string;
    gender: string;
    assignTo: any;
    dateFrom: any;
    dateTo: any;
  };

  pagination: {
    pageIndex: number;
    pageSize: number;
  };
}

@Injectable({
  providedIn: 'root'
})
export class ComplaintStateService {
  private readonly STORAGE_KEY = 'complaint_list_state';

  /**
   * Save filters and pagination to session storage
   */
  saveState(state: Partial<ComplaintListState>): void {
    const updatedState: ComplaintListState = {
      ...this.getDefaultState(),
      ...state
    };
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(updatedState));
  }

  /**
   * Restore state from session storage
   */
  restoreState(): ComplaintListState | null {
    try {
      const stored = localStorage.getItem(this.STORAGE_KEY);
      if (!stored) {
        return null;
      }
      return JSON.parse(stored);
    } catch {
      this.clearState();
      return null;
    }
  }

  /**
   * Clear the saved state
   */
  clearState(): void {
    localStorage.removeItem(this.STORAGE_KEY);
  }

  private getDefaultState(): ComplaintListState {
    return {
      filters: {
        complainantName: '',
        complaintNo: '',
        complaintCategoryId: null,
        complaintSubcategoryId: null,
        currentProcessId: null,
        divisionId: null,
        districtId: null,
        tehsilId: null,
        mouzaId: null,
        cnic: '',
        cellPhoneNo: '',
        email: '',
        gender: '',
        assignTo: null,
        dateFrom: null,
        dateTo: null
      },
      pagination: {
        pageIndex: 0,
        pageSize: 10
      }
    };
  }
}
